module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IItem {
        id: string;
        displayName: string;
    }

    interface ISingleMoverAlertJson extends IAlertJSON {
        [key: string]: any;
    }

    class MeevoAlertManagerReportIsRunConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$scope'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public selectedItems: IItem[];
        public selectedReportCategories: string[];
        public reportCriteria: { categoryIds?: string[]; objectStateEnum: number; };

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $scope: ng.IScope) {
            super(alertsManagerService);
        }

        get dataForReview() {
            return (this.selectedItems || []).map(item => item.displayName);
        }

        get alertConfiguration() {
            return {
                [this.data.configKey]: (this.selectedItems || []).map(item => item.id)
            }
        }

        onEdit(alertJSON: ISingleMoverAlertJson): void {
            this.selectedItems = alertJSON[this.data.configKey].map(itemId => (<IItem>{id: itemId}));
        }

        $onInit() {
            super.$onInit();
            this.selectedReportCategories = [];
            this.$scope.$watch(() => this.selectedReportCategories, () => {
                this.updateReportCriteria();
            }, true);
            this.updateReportCriteria();
        }

        updateReportCriteria(): void {
            this.reportCriteria = {
                categoryIds: this.selectedReportCategories,
                objectStateEnum: 2026
            };
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoAlertManagerReportIsRunConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/report-is-run-config/report-is-run-config.component.html',
            controller: MeevoAlertManagerReportIsRunConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
